if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true });
      } else {
        queueMicrotask(() => this.initialize());
      }
    }

    initialize() {
      if (this.initialized || !this.isConnected) return;
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      if (!this.elements.viewer) return;
      this.initialized = true;
      this.mql = window.matchMedia('(min-width: 750px)');
      this.navigation = this.querySelector('[data-ae-gallery-navigation]');
      if (this.navigation && this.elements.thumbnails) {
        this.navigation.hidden = false;
        this.navigation.querySelector('[data-ae-gallery-previous]').addEventListener('click', () => this.navigateMedia(-1));
        this.navigation.querySelector('[data-ae-gallery-next]').addEventListener('click', () => this.navigateMedia(1));
        this.updateNavigation();
      }
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      if (!activeMedia) return;
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      this.updateNavigation();
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    getNavigableThumbnails() {
      if (!this.elements.thumbnails) return [];
      return Array.from(this.elements.thumbnails.querySelectorAll('[data-target]')).filter((thumbnail) => {
        const media = this.elements.viewer.querySelector(`[data-media-id="${thumbnail.dataset.target}"]`);
        return media && !thumbnail.hidden && getComputedStyle(thumbnail).display !== 'none';
      });
    }

    navigateMedia(direction) {
      const thumbnails = this.getNavigableThumbnails();
      const current = thumbnails.findIndex((thumbnail) => thumbnail.querySelector('button[aria-current="true"]'));
      const next = thumbnails[current + direction];
      if (next) this.setActiveMedia(next.dataset.target, false);
    }

    updateNavigation() {
      if (!this.navigation) return;
      const thumbnails = this.getNavigableThumbnails();
      const current = Math.max(0, thumbnails.findIndex((thumbnail) => thumbnail.querySelector('button[aria-current="true"]')));
      this.navigation.hidden = thumbnails.length < 2;
      this.navigation.querySelector('[data-ae-gallery-current]').textContent = String(current + 1);
      this.navigation.querySelector('[data-ae-gallery-total]').textContent = String(thumbnails.length);
      this.navigation.querySelector('[data-ae-gallery-previous]').disabled = current === 0;
      this.navigation.querySelector('[data-ae-gallery-next]').disabled = current === thumbnails.length - 1;
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

